import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapMutations, mapActions } from 'vuex';
import categoryMixin from '@/views/creative/mixin/category.js';
import { groupItemMixin } from '@/views/creative/mixin/index.js';
import LanguageList from '../components/language-list.vue';
import AddResourceButton from './add-resource-button.vue';
import LanguageSelector from '../components/language-selector.vue';
import RemoveResourceButton from './remove-resource-button.vue';
import UpdateResourceButton from './update-resource-button.vue';
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category';
import DownloadButton from '@/components/DownloadButton/index.vue';
import resourceMixin from '@/views/creative/mixin/resource.js';

export default {
  mixins: [groupItemMixin, categoryMixin, resourceMixin],

  components: {
    LanguageSelector: LanguageSelector,
    LanguageList: LanguageList,
    AddResourceButton: AddResourceButton,
    RemoveResourceButton: RemoveResourceButton,
    UpdateResourceButton: UpdateResourceButton,
    DownloadButton: DownloadButton
  },

  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    page: function page(state) {
      return state.creative.template.page;
    }
  }), {
    defaultLanguageId: function defaultLanguageId() {
      return (this.resourceList.find(function (item) {
        return item.is_default === 1;
      }) || {}).id;
    },
    isLanguageEditable: function isLanguageEditable() {
      // 模板页面一直可以增加
      if (this.hasPermission('language.add-and-delete')) return true;
      // 其他页面根据 allow_add_language 的值控制是否开放这个功能
      return this.templateConfig.allow_add_language === 1;
    }
  }),

  watch: {
    resourceList: {
      handler: function handler(val) {
        if (val && val.length) {
          var zipLangList = val.filter(function (item) {
            return item.action !== 'del';
          });
          this.updateZipLangList(zipLangList);
        }
      },

      deep: true
    }
  },

  methods: _extends({}, mapMutations({
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResourceInZip: 'creative/template/updateCurrentResourceInZip',
    openAddLocalResourceInZipDialog: 'creative/template/openAddLocalResourceInZipDialog',
    updateActiveCategoryId: 'creative/template/updateActiveCategoryId',
    addValidator: 'creative/template/addValidator',
    updateCurrentLanguage: 'creative/template/updateCurrentLanguage',
    updateZipLangList: 'creative/template/updateZipLangList',
    removePreviewLanguage: 'creative/template/removePreviewLanguage'
  }), mapActions({
    changeDefaultResource: 'creative/template/changeDefaultResource'
  }), {
    handleSelectLanguage: function handleSelectLanguage(id) {
      var resource = this.resourceList.find(function (item) {
        return item.id === id;
      });
      this.changeDefaultResource(resource);
      this.updateCurrentLanguage(resource.zip_sign);
    },
    handleRemoveLanguage: function handleRemoveLanguage(resource) {
      var category = useIdToFindCategory({
        category: this.templateConfig.category,
        categoryId: resource.category_id
      });
      this.updateActiveCategoryId(category.id);
      // 图片字删除图片需要新增previewLanguage
      if (this.isImageLanguagePackage) {
        this.removePreviewLanguage(resource.zip_sign);
      }
    },
    isBasicResource: function isBasicResource(language) {
      return language && language.is_basic === 1;
    },
    getPreviewExtras: function getPreviewExtras(val, index) {
      if (val && val[index]) {
        try {
          return JSON.parse(val[index]);
        } catch (e) {
          this.$message.error('' + this.category.name + this.$t('playTurbo.creative.updateResourceInZipButton.error'));
        }
      }
      return {};
    },
    getFileMeta: function getFileMeta(resource, index) {
      var extras = this.getPreviewExtras(resource.preview_extras, index);
      return {
        name: extras.file_name,
        width: extras.width,
        height: extras.height,
        fileSize: extras.file_size
      };
    },
    handleChangeResource: function handleChangeResource(_ref) {
      var resource = _ref.resource,
          index = _ref.index,
          language = _ref.language;

      this.updateCurrentCategory(this.category);
      this.updateCurrentResource(language);
      this.updateCurrentResourceInZip(_extends({
        index: index,
        url: language.preview_urls[index]
      }, this.getFileMeta(this.basicResource, index)));
      this.openAddLocalResourceInZipDialog();
    }
  })
};